var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"buy_button_wrapper",class:{
        'light_buy_button_wrapper': !_vm.dark,
        'slim_buy_button_wrapper':  _vm.slim,
        'fill_buy_button_wrapper':  _vm.fill,
    },on:{"click":function($event){return _vm.submit()}}},[_c('strong',[_vm._v(" רכוש עכשיו ")]),_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }